var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneCallback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2812 0C13.2445 0 3.69177 0 2.71875 0C1.21967 0 0 1.21967 0 2.71875V21.2812C0 22.7803 1.21967 24 2.71875 24H14.2812C15.7803 24 17 22.7803 17 21.2812V2.71875C17 1.21967 15.7803 0 14.2812 0ZM10.3699 1.875C10.323 2.29633 9.96484 2.625 9.53125 2.625H7.46875C7.03516 2.625 6.677 2.29633 6.63013 1.875H10.3699ZM15.125 21.2812C15.125 21.7465 14.7465 22.125 14.2812 22.125H2.71875C2.25348 22.125 1.875 21.7465 1.875 21.2812V2.71875C1.875 2.25348 2.25348 1.875 2.71875 1.875H4.75238C4.802 3.33087 6.00116 4.5 7.46875 4.5H9.53125C10.999 4.5 12.198 3.33087 12.2476 1.875H14.2812C14.7465 1.875 15.125 2.25348 15.125 2.71875V21.2812Z",
    fill: "url(#phone_callback_gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.281 20.8751C10.7989 20.8751 11.2185 20.4554 11.2185 19.9376C11.2185 19.4198 10.7989 19.0001 10.281 19.0001H6.71854C6.20071 19.0001 5.78104 19.4198 5.78104 19.9376C5.78104 20.4554 6.20071 20.8751 6.71854 20.8751H10.281Z",
    fill: "#119ED9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_callback_gradient",
    x1: -0.103286,
    y1: 1.0453,
    x2: 21.0205,
    y2: 6.10792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallback);
export default __webpack_public_path__ + "static/media/phone_callback.9cbc0ba1d22085ab05b9bf067feae3ea.svg";
export { ForwardRef as ReactComponent };